import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import Text from '@atoms/Text/Text';
import SizeEnum from '@models/enums/SizeEnum';
import { IInfiniteScroll } from '@models/IInfiniteScroll';
import useScrolledToEnd from '@utility/hooks/useScrolledToEnd';
import { useEffect, useRef, useState } from 'react';

const InfiniteScroll = ({
  loadingLabel,
  containerProps,
  children,
  onLoadMore,
  isLoading,
  isLastPage,
}: React.PropsWithChildren<IInfiniteScroll>) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const hasScrolledToEnd = useScrolledToEnd(ref, isLoading);
  const [pageNum, setPageNum] = useState(1);

  useEffect(() => {
    if (!hasScrolledToEnd || isLoading || isLastPage) return;

    setPageNum(pageNum + 1);
  }, [hasScrolledToEnd, isLastPage]);

  useEffect(() => {
    onLoadMore(pageNum);
  }, [pageNum]);

  return (
    <div {...containerProps} ref={ref}>
      {!(pageNum === 1 && isLoading) && children}
      {isLoading && (
        <div className="tw-col-span-full tw-flex tw-justify-center tw-py-6">
          <LoadingSpinner size={SizeEnum.Small} loadingLabel={loadingLabel} />
          <Text variant="label-12" className="tw-ml-2 tw-text-grey-70">
            {loadingLabel}
          </Text>
        </div>
      )}
    </div>
  );
};
export default InfiniteScroll;
